import { useCallback, useState } from "react";
import { peekEvents } from "../api/calendarApi";
import { deskTransactions } from "../api/deskScope";
import { listFileIndex, loadFile } from "../api/filePacket";
import { peekBuyers } from "../api/buyersApi";
import { useAgentScope } from "./useAgentScope";

function peekSellers() {
  try {
    return JSON.parse(localStorage.getItem("dh_sellers") || "[]");
  } catch {
    return [];
  }
}

export function useFileSources() {
  const { session, listAgentId, excludeAgentId } = useAgentScope();
  const [tick, setTick] = useState(0);

  const reload = useCallback(() => setTick((n) => n + 1), []);

  const sources = {
    session,
    listAgentId,
    excludeAgentId,
    transactions: deskTransactions(session, listAgentId, excludeAgentId),
    buyers: peekBuyers(),
    sellers: peekSellers(),
    events: peekEvents(listAgentId, excludeAgentId),
    tick,
  };

  return { ...sources, reload };
}

export function useFileIndex() {
  const sources = useFileSources();
  const rows = listFileIndex({
    transactions: sources.transactions,
    buyers: sources.buyers,
    sellers: sources.sellers,
    events: sources.events,
  });
  return { ...sources, rows };
}

export function useFilePacket(routeId) {
  const sources = useFileSources();
  const file = loadFile(routeId, {
    transactions: sources.transactions,
    buyers: sources.buyers,
    sellers: sources.sellers,
    events: sources.events,
  });
  return { file, reload: sources.reload, session: sources.session };
}
